export const CYCLESRECEIVED = 'cycles/CYCLESRECEIVED';
export const CYCLECREATION = 'cycles/CYCLECREATION';
export const UPDATESELECTEDCYCLE = 'cycles/UPDATESELECTEDCYCLE';
export const CYCLEUPDATE = 'cycles/CYCLEUPDATE';
export const CYCLEDELETE = 'cycles/CYCLEDELETE';
export const CYCLEACTIVATED = 'cycles/CYCLEACTIVATED';
export const SUBSTITUTESUPDATED = 'cycles/SUBSTITUTESUPDATED';
export const RATES_MOVED = 'cycles/RATES_MOVED';
export const SET_UPDATED_CYCLE = 'cycles/SET_UPDATED_CYCLE';
